import {Store} from '../Store';

export interface TooltipsState {
  tooltip: {
    // id кнопки, которая закрывает тултипку
    targetId: string;
    // нода кнопки, которая закрывает тултипку
    targetNode: HTMLElement;
    // ноды, которые не должны закрывать тултику (например клики по канвасу)
    excludeNodes: HTMLElement[];
  } | null;
}

export class TooltipsStore extends Store<TooltipsState> {
  constructor() {
    super({
      tooltip: null,
    });
  }

  public setActiveTooltip(targetId: string, targetNode: HTMLElement, excludeNodes: HTMLElement[]): void {
    this.setValue('tooltip', {
      targetId,
      targetNode,
      excludeNodes,
    });
  }

  public hideTooltip(): void {
    this.setValue('tooltip', null);
  }

  public nodeIsTarget(node: HTMLElement): boolean {
    return this.state.tooltip?.targetNode === node;
  }

  public isExcludeNode(node: HTMLElement): boolean {
    return !!this.state.tooltip?.excludeNodes.includes(node);
  }

  public getTargetId(): string {
    return this.state.tooltip?.targetId || '';
  }
}
